
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import vuexStore from "@/store/vuex-store";
import _ from "lodash-es";
import UploadImage from "@/lib/common/uploadImage";
import Agent from "@/lib/common/agent";
import Video from "@/lib/common/video";
import request from "@/lib/request/request";
import Config from "@/config/config";
@Component({
  components: {}
})
export default class IdCardExam extends Vue {
  connectCode = "";
  step = 0;
  imgUrl: any = "";
  imgData: any = null;
  file: any = null;

  imgUrl2: any = "";
  imgData2: any = null;
  file2: any = null;

  loading = false;
  redirectUrl = "";

  imageType = "idcard"; // "idcard" "passport"
  useRtc = false;
  isSelected = false;
  locationOrigin = "";

  async mounted() {
    this.connectCode = (this.$route.query.c as string).replace(
      /[^a-zA-Z0-9]/g,
      ""
    );
    const resp = await request.postExamApi("api/coder/interview/get", {
      code: this.connectCode,
      memberType: 2,
      privacyType: 2
    });
    const data = resp.data;
    if (data.code == 0) {
      this.redirectUrl = data.data.miniProgram;
    }

    this.locationOrigin = Config.homePageHost;
    if (!Agent.isMobile()) {
      //pass
    } else if (!Agent.isSupport()) {
      this.notSupport();
    }
  }

  back() {
    if (!this.useRtc && this.step == 3) {
      this.step -= 2;
    } else {
      this.step -= 1;
    }
  }

  notSupport() {
    this.useRtc = false;
  }

  openCamera(type = "") {
    console.log(type);
    if (type == "face") {
      if (!this.useRtc) {
        this.file = null;
        this.imgUrl = "";
        this.imgData = null;
        (this.$refs.cameraInput as HTMLElement).click();
        return;
      }
    } else {
      if (!this.useRtc) {
        this.file2 = null;
        this.imgUrl2 = "";
        this.imgData2 = null;
        (this.$refs.cameraInput2 as HTMLElement).click();
        return;
      }
      this.imageType = type;
    }

    this.step += 1;
    try {
      const constraints = { audio: false, video: true };
      Video.getUserMedia(constraints).then((stream: any) => {
        const video: HTMLVideoElement = this.$refs
          .cameraVideo as HTMLVideoElement;
        if ("srcObject" in video) {
          video.srcObject = stream;
        } else {
          // @ts-ignore
          video.src = URL.createObjectURL(stream);
        }
        video.onloadedmetadata = e => {
          video.play();
        };
      });
    } catch (e) {
      this.notSupport();
    }
  }

  takeShot() {
    const canvas: HTMLCanvasElement = this.$refs
      .cameraCanvas as HTMLCanvasElement;
    const video: HTMLVideoElement = this.$refs.cameraVideo as HTMLVideoElement;
    const maskCard: HTMLElement = this.$refs.maskCard as HTMLElement;
    console.log(maskCard.offsetTop);
    // console.log(maskCard.offsetLeft)
    // console.log(maskCard.offsetWidth)
    // console.log(maskCard.offsetHeight)
    //
    console.log(video.offsetTop);
    console.log(video.offsetLeft);
    console.log(video.offsetWidth);
    console.log(video.offsetHeight);
    //
    // console.log(video.videoHeight)
    const screenRatio = video.offsetHeight / video.offsetWidth;
    const syRatio = maskCard.offsetTop / video.offsetHeight;

    const sx = 0;
    const sy =
      (video.videoWidth * screenRatio - video.videoWidth) / 2 -
      video.videoWidth * screenRatio * syRatio;
    const sw = (maskCard.offsetWidth / video.offsetWidth) * video.videoWidth;

    const sh = (maskCard.offsetHeight / maskCard.offsetWidth) * sw;
    console.log(sx);
    console.log(sy);
    console.log(sw);
    console.log(sh);
    const ctx = canvas.getContext("2d");
    canvas.width = sw;
    canvas.height = sh;
    if (ctx) {
      ctx.drawImage(video, sx, sy, sw, sh, 0, 0, sw, sh);
      canvas.toBlob((blob: any) => {
        this.file = new File([blob], "idImage", { type: "image/jpg" });
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = () => {
          this.imgData = reader.result;
          this.step += 1;
        };
      }, "image/jpg");
    }
  }

  start() {
    if (!this.isSelected) {
      this.$message.error("请同意《海纳认证服务协议》");
      return;
    }
    this.step = 1;
  }

  async fileChange(ev: any) {
    console.log(ev);
    const file = ev.target.files[0];
    this.file = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imgData = reader.result;
      this.step += 2;
    };
  }

  async fileChange2(ev: any) {
    console.log(ev);
    const file = ev.target.files[0];
    this.file2 = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imgData2 = reader.result;
      this.step += 2;
    };
  }

  async upload() {
    this.loading = true;
    try {
      this.imgUrl = await UploadImage.uploadImg(this.file);
      this.imgUrl2 = await UploadImage.uploadImg(this.file2);
      console.log(this.imgUrl);
      const resp = await request.postExamApi(
        "api/coder/interview/recognition2",
        {
          code: this.connectCode,
          imageUrlA: this.imgUrl,
          imageUrlB: this.imgUrl2
        }
      );
      const data = resp.data;
      if (data.code == 0) {
        this.step += 1;
      }
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  finish() {
    window.location.href = this.redirectUrl;
  }
}
